import {
  Form,
  Row,
  Col,
  Input,
  Select,
  Button,
  Checkbox,
  Popconfirm,
  notification,
  Popover,
  Modal,
  Radio,
  Dropdown,
  Menu,
  Space,
} from 'antd'
import React, { ReactElement, useEffect, useRef, useState } from 'react'
import styles from './newCommodity.module.css'
import { useDispatch, useSelector } from 'react-redux'
import { NavBar } from '../../compnents/nav/NavBar'
import { getCommodityDetail, getShopGoodsNo, getSyncInventoryAsync, getZjWbCodes, logoutOrenableCommodity, saveCommodityAsync, selectCommodityDetail, selectCommodityId, selectShopNo, setCommodityDetail, setSelectId } from '../commodity/commoditySlice'
import { selectCredentials, selectInsuranceArray, selectTenantCategory, selectTenantCityCode } from '../../app/applicationSlice'
import { useHistory, useLocation } from 'react-router-dom'
import { RecipeItemInput } from '../commodity/componment/RecipeItemInput'
import { getCommonCodeCompletions, ItemCompletionType, selectCommonCodes } from '../completion/completionSlice'
import { CaretDownFilled, CaretUpFilled, CheckCircleOutlined, CloseOutlined, ExclamationCircleFilled } from '@ant-design/icons'
import { unwrapResult } from '@reduxjs/toolkit'
import { RootDispatch } from '../../app/store'
import { getChrgitmLvName, getChrgitmLvNameNoLei, getinventoryAlertName, getMaterialsCategoryName, getMaterialsName, getQualityControlCategory, inventoryAlertCate, Materiales, qualityControlCategories } from '../../models/commodity'
import { CommonCodeCategory } from '../../models/commoncode'
import { BillingCategoryName, InvoiceBillingCategories } from '../../models/billingCategory'
import DrugImg from './image/drug.png'
import DrugImg1 from './image/drug1.png'
import DrugImg2 from './image/drug2.png'
import DrugImg3 from './image/drug3.png'
import { RecipeItemFieldInput } from '../treatment/editor/components/RecipeItemFieldInput'
import { getNewNormalFrequencyCodeCalc, getNormalFrequencyCodeCalc } from '../../models/recipe'
import { getOtcCategoryName, OtcCategories } from '../../models/Otccategory'
import { getFollowUpPeopleList } from '../followUp/followUpPageSlice'
import { MedicalModal } from '../commodity/medical/MedicalModal'
import { SupplierModal } from '../savebusiness/modal'
import { SupplierModal as SupplierSaveModal } from '../wms/modal'
import { setCurrent } from '../wms/supplierSlice'
import { selectSettings } from '../user/setting/settingSlice'
import { Checks } from '../../models/setting'
import QuestionTipsImg from '../../compnents/icons/png/questionTips.png'
import { getNewAutoChangePriceUseDays } from '../../models/RecipeItemAutoChangePrice'

const { Option } = Select
const { TextArea } = Input
const layout = {
  labelCol: { span: 24 },
  wrapperCol: { span: 22 },
}

const firstColumnLayout = {
  labelCol: {
    flex: '0 0 6rem',
  },
}

const remarkColumnLayout = {
  labelCol: {
    flex: '0 0 6rem',
  },
  wrapperCol: { span: 24 },
}

const titleColumnLayout = {
  labelCol: {
    flex: '0 0 9rem',
  },
}

export const NewDurgSaveform = (props: {
  billingCategory?: any
  hilistCode?: any
  mappingId?: any
  flag?: any
  materialCategory?: any //类别
  details?: any //码上放心过来的
  refresh?: (v?: any) => void
}): ReactElement => {
  const history = useHistory()

  const [form] = Form.useForm()

  const location: any = useLocation()

  const dispatch = useDispatch<RootDispatch>()

  const capacityUnitRef = useRef<any>(null) //容量单位输入框

  const capacityRef = useRef<any>(null) //容量输入框

  const drugMarkCodeRef = useRef<any>(null) //商品标识码输入框

  const componentsRef = useRef<any>(null) //成分含量输入框

  const componentsUnitRef = useRef<any>(null) //成分含量单位输入框

  const minPackNumsRef = useRef<any>(null) //最小包装数量输入框

  const minPackUnitRef = useRef<any>(null) //最小包装单位输入框

  const accountUnitRef = useRef<any>(null) //账户单位输入框

  // props?.materialCategory 一般是码上放心弹窗过来的
  const materialCategory = location?.state?.materialCategory?.toString() ? location?.state?.materialCategory : props?.materialCategory

  const credentials = useSelector(selectCredentials)

  const shopNo = useSelector(selectShopNo)

  const selectId = useSelector(selectCommodityId)

  const detail: any = useSelector(selectCommodityDetail)

  const insuranceArray = useSelector(selectInsuranceArray)

  const settings = useSelector(selectSettings)

  const cityCode = useSelector(selectTenantCityCode)

  const tenantCategory = useSelector(selectTenantCategory)  // 17 校医务室 不展示进价售价

  const YPdata = useSelector(selectCommonCodes(CommonCodeCategory.Durg))  // 药品分类

  const [source, setSource] = useState(0)

  const [open, setOpen] = useState(false)

  const [writeBack, setWriteBack] = useState(false)

  const [isSubmitLoading, setIsSubmitLoading] = useState<any>(false) //提交loading

  const [medicalModalVisible, setMedicalModalVisible] = useState(false) //医保目录弹窗

  const [medicalModalInfo, setMedicalModalInfo] = useState<any>() //医保目录信息

  const [ZYCYPshow, setZYCYPshow] = useState(false) //是否中药材/饮片

  const [isModalVisible, setIsModalVisible] = useState(false) //生产厂家供应商弹窗选择

  const [isAddModalVisible, setIsAddModalVisible] = useState(false) //添加生产厂家供应商弹窗

  const [tenantSupplierId, setTenantSupplierId] = useState<any>(0) //生产厂家供应商id

  const [sourceMaterialsCatalogId, setSourceMaterialsCatalogId] = useState<any>() //生产厂家供应商id

  const [splitTag, setSplitTag] = useState(false) //是否拆零

  const [flag, setFlag] = useState<any>() //区分生产厂家还是供应商

  const [extendInformation, setExtendInformation] = useState<any>() //扩展信息箭头

  const [YJYKCSetting, setYJYKCSetting] = useState<any>() //预警与库存设置箭头

  const [isVisible, setIsVisible] = useState(false)

  const [selectJL, setSelectJL] = useState<any>('0')

  const [genderReminderFlag, setGenderReminderFlag] = useState<any>(false) //指定性别预警

  const [ageReminderFlag, setAgeReminderFlag] = useState<any>(false) //指定年龄预警

  const [doctors, setDoctors] = useState<any>([]) //限定开单医生

  const [drugMarkCCodePlaceholder, setDrugMarkCCodePlaceholder] = useState('') //商品标识码(占位符

  const [showGLButton, setShowGLButton] = useState(false) //商品标识码(输入展示关联按钮

  const [YPBSMValue, setYPBSMValue] = useState('')

  const [isSPBSMVisible, setIsSPBSMVisible] = useState(false) //是否展示商品标识码弹窗

  const [drugMarkCCodeList, setDrugMarkCCodeList] = useState<any[]>([]) //商品标识码关联列表

  const [isChecked, setIsChecked] = useState<any>(false) //是否生成调价记录

  const [loading, setLoading] = useState(false) //同步售价到库存弹窗loading

  const [sureVisible, setSureVisible] = useState(false) //同步售价到库存弹窗

  const [doseUnitData, setDoseUnitData] = useState<any>() //成分含量单位

  const [unitInfo, setUnitInfo] = useState<any>({}) //单位信息

  const [doseUnitChange, setDoseUnitChange] = useState<any>(false) //是否手动修改过常用用量单位

  const isAutoSettingDoseUnitRef = useRef(false) // 程序自动设置doseUnit时跳过onChange

  const [selectDoseUnit, setSelectDoseUnit] = useState<any>('') //常用用量单位

  const doseUnit = form.getFieldValue('doseUnit') || '' // 常用用量单位

  const [saveAndContinue, setSaveAndContinue] = useState<any>(false) //是否保存并继续

  const [memberDiscountType, setMemberDiscountType] = useState(0) // 会员价折扣类型：0折扣 1特价

  const [cachedSpecialPrice, setCachedSpecialPrice] = useState<any>(null)

  const [cachedDiscountPrice, setCachedDiscountPrice] = useState<any>(null)

  const drugCategory = form.getFieldValue('drugCategory') || '' // 药品分类
  useEffect(() => {
    const capacityUnit = unitInfo?.capacityUnit || '' // 容量单位
    const componentsUnit = unitInfo?.componentsUnit || '' // 成分含量单位 
    const minPackUnit = unitInfo?.minPackUnit || '' // 最小包装单位
    const accountUnit = unitInfo?.accountUnit || '' // 包装单位

    // 生成数组：有值才生成对象，没值为 null，最后过滤掉假值
    let list: any = ZYCYPshow ? [
      {
        name: '适量',
      },
      minPackUnit && {
        name: minPackUnit,
      },
      accountUnit && {
        name: accountUnit,
      },
    ]
      : [
        {
          name: '适量',
        },
        capacityUnit && {
          name: capacityUnit,
        },
        componentsUnit && {
          name: componentsUnit,
        },
        minPackUnit && {
          name: minPackUnit,
        },
        accountUnit && {
          name: accountUnit,
        },
      ].filter(Boolean); // 关键：过滤掉 false、null、undefined、空字符串
    const uniqueMap = new Map();
    list.forEach((item: any) => {
      uniqueMap.set(item.name, item);
    });
    list = Array.from(uniqueMap.values());
    // 更新到下拉数据
    setDoseUnitData(list?.filter((v: any) => v != ''));
    // 如果选中的常用用量单位不在下拉中，清空常用用量单位
    const flag = list?.length ? list?.filter((item: any) => item?.name == doseUnit) : [];

    if (!flag?.length && !doseUnitChange) {
      // 非中药默认选中最小包装单位
      // 中药默认选中最小包装单位，没有再包装单位
      isAutoSettingDoseUnitRef.current = true
      form.setFieldsValue({
        doseUnit: !ZYCYPshow ? minPackUnit : minPackUnit || accountUnit,
      })
      isAutoSettingDoseUnitRef.current = false
      setDoseUnitChange(false)
    } else if (!flag?.length && doseUnitChange) {
      isAutoSettingDoseUnitRef.current = true
      form.setFieldsValue({
        doseUnit: '',
      })
      isAutoSettingDoseUnitRef.current = false
    }


  }, [unitInfo, doseUnit, selectJL, ZYCYPshow, drugCategory, doseUnitChange]);

  useEffect(() => {
    if (selectJL == '0') {
      setUnitInfo({
        ...unitInfo,
        capacityUnit: '',
      })
    }
  }, [selectJL])

  useEffect(() => {
    if (!localStorage.getItem('time1')) {
      localStorage.setItem('time1', JSON.stringify(new Date()))
      setOpen(true)
    } else {
      setOpen(false)
    }
  }, [])

  useEffect(() => {
    if (sureVisible) {
      const SFSCBDJLHTJJL = localStorage?.getItem('SFSCBDJLHTJJL')
      setIsChecked(SFSCBDJLHTJJL == 'true' ? true : false)
    }
  }, [sureVisible])


  // 类别回填
  useEffect(() => {
    form.setFieldsValue({
      materialsCategory: materialCategory,
    })
  }, [materialCategory])

  // 初次默认进来清数据
  useEffect(() => {
    return () => {
      resetForm()
    }
  }, [])

  const resetForm = () => {
    form.resetFields()
    setComponentItem(undefined)
    dispatch(setSelectId(0))
    dispatch(setCommodityDetail({}))
    setSplitTag(false)
    setDrugMarkCCodeList([])
    setShowGLButton(false)
    setDrugMarkCCodePlaceholder('')
    setMedicalModalInfo({})
    setSourceMaterialsCatalogId('')
    setExtendInformation(false)
    setYJYKCSetting(false)
    setGenderReminderFlag(false)
    setAgeReminderFlag(false)
    setUnitInfo({})
    setDoseUnitData([])
    setSelectDoseUnit('')
    setDoseUnitChange(false)
  }

  // 回填数据
  useEffect(() => {
    if (JSON.stringify(detail) !== '{}') {
      setFileds(detail, true)
    } else if (props?.details && JSON.stringify(props?.details) !== '{}') {
      setFileds(props?.details, false)
    } else {
      const drugCategory = form.getFieldValue('drugCategory') || YPdata?.[0]?.name || ''
      // 新增默认值
      form.setFieldsValue({
        maintainCategory: 0, //养护等级 (一般养护)
        noTraceCodeFlag: '0', //药品标识码  (有码)
        drugCategory: drugCategory, //药品分类 (有选中的就是选中的 没有就是第一个)
      })
      setOTCBILL(drugCategory)
    }
  }, [detail, props?.details, YPdata])

  // 下拉回填
  const recipeItemInputSetFileds = (m: any) => {
    const materialsCategory = form.getFieldValue('materialsCategory')
    const no = form.getFieldValue('no')
    form.setFieldsValue({
      ...m,
      ...m.mixInsuranceCatalog,
      ...m.materialsCatalogPlus,
      no: m.no == '' ? no : m.no, //商品编码
      allStr: m.name, //药品搜索
      autoMergeLimit: m.autoMergeLimit == -1 ? '' : m.autoMergeLimit, //自动清斗设置
      materialsCategory: m.materialsCategory == -1 ? materialsCategory : m.materialsCategory, //类别
      billingCategory: m.billingCategory.toString(), //开票项目
      noTraceCodeFlag: detail?.noTraceCodeFlag < 0 ? '0' : (detail?.noTraceCodeFlag)?.toString(), //药品标识码
      compoundTag: m.compoundTag == -1 ? '' : m.compoundTag, //复方标志
      splitTag: 0,
      stockPrice: null, //进价/元
      forceYearAccount: 0, //医保结算方式
      retailPrice: '',
      splitPrice: m?.splitPrice > 0 ? m?.splitPrice : '', //拆零售价/元
    })
    // 跟编辑回填的公共部分
    commonSetFiles({ ...m, ...m?.materialsCatalogPlus })
    setUnitInfo({
      ...unitInfo,
      capacityUnit: m?.capacityUnit || '',
      componentsUnit: m?.componentsUnit || '',
      minPackUnit: m?.minPackUnit || '',
      accountUnit: m?.accountUnit || '',
    })
  }

  // 编辑回填
  const setFileds = (detail?: any, flag?: boolean) => {
    const hilistName = detail?.mixInsuranceCatalog?.hilistName
    const chrgitmLv = detail?.mixInsuranceCatalog?.chrgitmLv
    const memberInterestVO = detail?.memberInterestVO || {}
    form.setFieldsValue({
      ...detail,
      ...detail?.mixInsuranceCatalog,
      ...detail?.materialsCatalogPlus,

      useDays: detail?.useDays == -1 ? '' : detail?.useDays, //用药天数
      autoMergeLimit: detail?.autoMergeLimit == -1 ? '' : detail?.autoMergeLimit, //自动清斗设置
      noTraceCodeFlag: detail?.noTraceCodeFlag < 0 ? '0' : (detail?.noTraceCodeFlag)?.toString(), //药品标识码

      otc: detail?.otc !== 10 ? detail?.otc : undefined, //otc

      splitTag: detail?.splitTag > 0 ? true : false, //允许拆零
      forceYearAccount: Number(detail?.forceYearAccount) > 0 ? Number(detail?.forceYearAccount) : 0, //医保结算方式
      splitPrice: detail?.splitPrice > 0 ? detail?.splitPrice : '', //拆零售价/元
      stockPrice: detail?.stockPrice < 0 ? '' : detail?.stockPrice, //进价/元
      retailPrice: flag ? (detail?.retailPrice == -1 ? '' : detail?.retailPrice) : '', //零售价/元

      hilistName: (hilistName ? hilistName : '') + (chrgitmLv ? (' [' + getChrgitmLvNameNoLei(chrgitmLv) + '] ') : ''), //医保名称 + 甲乙分类
      rewriteHilistCode: detail?.rewriteHilistCode, //自定义医保国码
      proviceHilistCode: detail?.proviceHilistCode || '', //医保省市编码

      ageReminder: detail?.rules?.ageReminder == '1' ? true : false, //开方年龄限制开关
      judgmentType: detail?.rules?.judgmentType < 0 ? '' : detail?.rules?.judgmentType?.toString(),
      ageLimit: detail?.rules?.ageLimit < 0 ? '' : detail?.rules?.ageLimit?.toString(),

      genderReminder: detail?.rules?.genderReminder == '1' ? true : false, //开方性别限制
      gender: detail?.rules?.gender > 0 ? detail?.rules?.gender?.toString() : '',
      discountType: memberInterestVO?.discountType === -1 ? 0 : (memberInterestVO?.discountType ?? 0),
      memberPrice: memberInterestVO?.price === -1
        ? undefined
        : memberInterestVO?.discountType === 1 && memberInterestVO?.price != null
          ? Number(memberInterestVO.price).toFixed(5)
          : memberInterestVO?.price,
    })

    setMemberDiscountType(memberInterestVO?.discountType === -1 ? 0 : (memberInterestVO?.discountType ?? 0))
    if (memberInterestVO?.discountType === 1 && memberInterestVO?.price != null && memberInterestVO?.price !== -1) {
      setCachedSpecialPrice(Number(memberInterestVO.price).toFixed(5))
    }
    // 医保信息
    const hilistPricUplmtAmt = detail?.mixInsuranceCatalog?.hilistPricUplmtAmt
    setMedicalModalInfo({
      ...detail,
      ...detail?.mixInsuranceCatalog,
      aprvno: detail?.mixInsuranceCatalog?.aprvno || detail?.approvalNumber, //批准文号
      hilistPricUplmtAmt: hilistPricUplmtAmt >= 99999 ? 0 : hilistPricUplmtAmt, //医保限价
    })
    // 跟下拉回填的公共部分
    commonSetFiles({ ...detail, ...detail?.materialsCatalogPlus })
    setDoseUnitChange(true)
    setSelectDoseUnit(detail?.doseUnit || '')

    // 码上放心
    if (props?.flag == '/msfxFlag') {
      getZjWbCodesAsync(detail?.name)
    }
    setAgeReminderFlag(detail?.rules?.ageReminder == '1' ? true : false)
    setGenderReminderFlag(detail?.rules?.genderReminder == '1' ? true : false)


    setSplitTag(detail?.splitTag == -1 ? '' : detail?.splitTag)
    setTenantSupplierId(detail?.tenantSupplierId)
  }

  const commonSetFiles = (m?: any) => {
    form.setFieldsValue({
      tax: m?.tax > 0 ? m?.tax : '', //项目税率
      chrgitmLv: getChrgitmLvName(m.mixInsuranceCatalog.chrgitmLv), //甲乙分类
      allowUseUserId: m?.allowUseUsers?.length ? m?.allowUseUsers?.map((v: any) => v?.userId) : [], //限定开单医生
      noTraceCodeFlag: m?.noTraceCodeFlag < 0 ? '0' : (m?.noTraceCodeFlag)?.toString(), //药品标识码

      anaesthesiaTag: m.anaesthesiaTag > 0 ? true : false, //是否毒药物
      narcoticTag: m.narcoticTag > 0 ? true : false, //是否麻醉药物
      psychotropic1Tag: m.psychotropic1Tag > 0 ? true : false, //是否精一药物
      psychotropic2Tag: m.psychotropic2Tag > 0 ? true : false, //是否精二药物
      stimulantTag: m.stimulantTag > 0 ? true : false, //是否兴奋药物
      ephedrineTag: m.ephedrineTag > 0 ? true : false, //是否麻黄碱
      antibioticTag: m.antibioticTag > 0 ? true : false, //是否抗生素
      basicMedicineTag: m.basicMedicineTag > 0 ? true : false, //是否基药
      skinTestTag: m.skinTestTag > 0 ? m.skinTestTag : 0, //皮试标志 
      maintainCategory: m.maintainCategory > 0 ? m.maintainCategory : 0, //养护等级
      inventoryAlert: m.inventoryAlert > 0 ? m.inventoryAlert : '', //库存下限设置

      capacity: m?.capacity > 0 ? m?.capacity : '', //容量
      components: m?.components > 0 ? m?.components : '', //成分含量
      minPackNums: m?.minPackNums > 0 ? m?.minPackNums : '', //最小包装数量
      normalDose: detail?.doseUnit == '适量' ? '' : m.normalDose > 0 ? m.normalDose : '', //常用用量 
      limitCount: m?.limitCount > 0 ? m?.limitCount : '', //医保限量开方
      putCategory: m?.putCategory >= 0 ? m?.putCategory : '', //存储分类

      qualityControlCategory: m?.qualityControlCategory >= 0 ? m?.qualityControlCategory : '', //质量管理分类
      drugMarkCode: m?.drugMarkCode?.split(',')?.[0] || '', //药品标识码
    })


    if (m?.drugCategory === '中药材/饮片') {
      setZYCYPshow(true) //中药材
    } else {
      setZYCYPshow(false) //药品
    }

    setDrugMarkCCodeList(m?.drugMarkCode ? m?.drugMarkCode?.split(',') : [])
    // 剂量回填
    getJLFiles(m)

    if (m?.billingCategory == '03') {
      setComponentItem({
        name: m?.name,
        billingCategory: m?.billingCategory,
      })
    } else {
      setComponentItem({
        name: m?.name,
        billingCategory: m?.billingCategory,
        tenantSupplierName: m?.tenantSupplierName,
        approvalNumber: m?.approvalNumber,
        genericName: m?.genericName,
        accountUnit: m?.accountUnit,
        packSpec: m?.packSpec
      })
    }
  }

  // 医保匹配
  const matching = () => {
    if (!insuranceArray?.length) {
      notification.error({ message: '请先开通医保！' })
      return
    }

    if (!componentItem.name || !componentItem.billingCategory) {
      notification.error({ message: '请先完善药品基本信息！' })
      return
    }

    setWriteBack(false)
    setMedicalModalVisible(true)
    // 医保目录查询需要展示的字段
    setComponentItem({
      ...componentItem,
      genericName: form.getFieldValue('genericName'),
      accountUnit: form.getFieldValue('accountUnit'),
      packSpec: form.getFieldValue('packSpec'),
    })
  }

  // 从医保目录搜索点击弹窗回填信息
  const getInsuranceRrecordSetFiles = (item: any) => {
    const data = {
      ...item,
      hiListSpec: item.spec, //医保规格
      chrgitmLv: getChrgitmLvName(item.chrgitmLv), //甲乙分类
    }

    const name = form.getFieldValue('name')
    const doseCategory = form.getFieldValue('doseCategory')
    const accountUnit = form.getFieldValue('accountUnit')
    const tenantSupplierName = form.getFieldValue('tenantSupplierName')
    const otc = form.getFieldValue('otc')
    const proviceHilistCode = form.getFieldValue('proviceHilistCode') || item?.proviceHilistCode//医保省市编码
    const approvalNumber = form.getFieldValue('approvalNumber')

    form.setFieldsValue({
      // 匹配医保编码时，不要把已经填写的省码清空
      hilistName: (data.hilistName ? data.hilistName : '') + (data.chrgitmLv ? (' [' + data.chrgitmLv + '] ') : ''), //医保名称 + 甲乙分类
      hiListCode: data.hiListCode, //医保国码
      proviceHilistCode: !writeBack ? proviceHilistCode : data?.proviceHilistCode, //医保省市编码
      limitCount: data?.limitCount == -1 ? '' : data?.limitCount,//医保限量开方
      approvalNumber: data.aprvno, //批准文号

      //顺便回写基础目录信息 writeBack 医保目录标志
      name: writeBack ? data.hilistName : name,
      genericName: data.hilistName, //商品名
      mnemonicCode: data?.mnemonicCode, //助记码
      wubiCode: data?.wubiCode, //五笔码
      doseCategory: data.dosformName || doseCategory, //剂型
      accountUnit: data.pacunt || accountUnit,//包装单位
      tenantSupplierName: data.prodentpName || tenantSupplierName, //生产厂家
      otc: data.otcFlag === '0' || data.otcFlag === '1' ? parseInt(data.otcFlag) : otc, //是否OTC
    })

    const limitAmount = parseFloat(item.hilistPricUplmtAmt)
    const hilistPricUplmtAmt = limitAmount >= 99999

    if (!isNaN(limitAmount) && limitAmount > 0 && limitAmount < 99999 && !form.getFieldValue('retailPrice')) {
      form.setFieldsValue({
        retailPrice: limitAmount,
      })
    }
    if (hilistPricUplmtAmt) {
      setMedicalModalInfo({
        ...data,
        hilistPricUplmtAmt: 0,
      })
    } else {
      setMedicalModalInfo(data)
    }

    setComponentItem({
      ...componentItem,
      name: writeBack ? item.hilistName : name,
      approvalNumber: item.aprvno || approvalNumber,
      tenantSupplierName: item.prodentpName || tenantSupplierName, //生产厂家
    })
  }

  // 剂量标题选中
  const getJLFiles = (detail?: any) => {
    const materialsCatalogPlus = {
      minPackUnit: detail?.minPackUnit || '',
      capacityUnit: detail?.capacityUnit || '',
      componentsUnit: detail?.componentsUnit || '',
      capacity: detail?.capacity || '',
      components: detail?.components || '',
    }
    // 中药材/饮片没有 剂量 去掉俩单位
    if (detail?.drugCategory === '中药材/饮片') {
      setUnitInfo({
        ...unitInfo,
        componentsUnit: '', //成分含量单位
        capacityUnit: '', //容量单位
        minPackUnit: materialsCatalogPlus?.minPackUnit, //最小包装单位
        accountUnit: detail?.accountUnit, //包装单位
      })
    } else {
      setUnitInfo({
        ...unitInfo,
        capacityUnit: materialsCatalogPlus?.capacityUnit,//容量单位
        componentsUnit: materialsCatalogPlus?.componentsUnit, //成分含量单位
        minPackUnit: materialsCatalogPlus?.minPackUnit, //最小包装单位
        accountUnit: detail?.accountUnit, //包装单位
      })
    }
    const capacity = materialsCatalogPlus?.capacity > 0 ? materialsCatalogPlus?.capacity : ''
    const components = materialsCatalogPlus?.components > 0 ? materialsCatalogPlus?.components : ''

    console.log(capacity, components, materialsCatalogPlus, "materialsCatalogPlus")
    // 四个值都有的情况下就是回填容量
    if (capacity && materialsCatalogPlus?.capacityUnit && components && materialsCatalogPlus?.componentsUnit) {
      setSelectJL('1')
    } else {
      setSelectJL('0')
    }
  }

  useEffect(() => {
    if (isVisible) {
      // 剂量选中默认值
      setSelectJL(selectJL || '0')
    }
  }, [isVisible])

  // 获取药品编码
  useEffect(() => {
    if (!selectId) {
      dispatch(getShopGoodsNo())
    }
  }, [selectId])

  // 回填药品编码
  useEffect(() => {
    if (shopNo) {
      form.setFieldsValue({
        no: shopNo,
      })
    }
  }, [shopNo])

  const [componentItem, setComponentItem] = useState<any>({
    name: '',
    billingCategory: '',
    tenantSupplierName: '',
    approvalNumber: '',
    genericName: '',
    accountUnit: '',
    packSpec: '',
  })

  useEffect(() => {
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Durg, '')) // 药品分类
    // dispatch(getCommonCodeCompletions(CommonCodeCategory.Dosago, ''))
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Unit, '')) // 单位
    // dispatch(getCommonCodeCompletions(CommonCodeCategory.Usage, ''))
    dispatch(getCommonCodeCompletions(CommonCodeCategory.Frequency, '')) // 频次
    form.setFieldsValue({
      compoundTag: 1, //复方标志
    })
  }, [])

  // 获取限定开单医生列表
  useEffect(() => {
    dispatch(getFollowUpPeopleList({ state: 1, current: 1, size: 1000 }))
      .then(unwrapResult)
      .then((ds: any) =>
        setDoctors(
          ds?.records?.map((v: any) => {
            return {
              label: v?.realname,
              value: v?.id,
            }
          })
        )
      )
      .catch(() => {
        // do nothing
      })
  }, [])

  // 获取详情
  useEffect(() => {
    if (selectId) {
      const billingCategory = location.state?.record?.billingCategory || props?.billingCategory || ''
      const hilistCode = location.state?.record?.hilistCode || props?.hilistCode || ''
      const mappingId = location.state?.record?.mappingId || props?.mappingId || ''
      const insuranceCode = location.state?.record?.insuranceCode || insuranceArray?.[0]?.insuranceCode || ''
      const insuAdmdvs = insuranceArray?.[0]?.insuranceCuntryCode || ''
      dispatch(
        getCommodityDetail({
          id: selectId,
          billingCategory: billingCategory,
          hilistCode: hilistCode,
          insuranceCode: insuranceCode,
          mappingId: mappingId,
          insuAdmdvs: insuAdmdvs,
        })
      )
    }
  }, [selectId])

  // 通用名输入获取
  const getWubi = (e: any) => {
    getZjWbCodesAsync(e)
    setComponentItem({
      ...componentItem,
      name: e,
    })
  }

  // 修改开票项目 改变类别
  const getBillingCategoryChange = (e: any) => {
    if (e == "01") {//西药
      form.setFieldsValue({
        drugCategory: '化学药制剂',
      })
      setZYCYPshow(false)
    } else if (e == "02") { //中成药
      form.setFieldsValue({
        drugCategory: '中成药',
      })
      setZYCYPshow(false)
    } else if (e == "03") {//中草药
      form.setFieldsValue({
        drugCategory: '中药材/饮片',
      })
      setZYCYPshow(true)
    } else { //其他
      form.setFieldsValue({
        drugCategory: '其他',
      })
      setZYCYPshow(false)
    }
    setComponentItem({
      ...componentItem,
      billingCategory: e,
    })
  }

  const setOTCBILL = (key: any) => {
    const minPackUnit = form.getFieldValue('minPackUnit') || '' // 最小包装单位
    const accountUnit = form.getFieldValue('accountUnit') || '' // 包装单位
    switch (key) {
      case '中药材/饮片':
        setZYCYPshow(true)
        // 切换中药材/饮片 时，清空成分含量单位跟容量单位,
        setUnitInfo({
          ...unitInfo,
          componentsUnit: '',
          capacityUnit: '',
          minPackUnit: 'g', //包装单位为g
          accountUnit: 'g',//最小包装数量是g
        })
        form.setFieldsValue({
          otc: 10,
          billingCategory: '03', //开票项目 (中草药)
          compoundTag: 1, //复方标志 ( 单味)
          normalDose: '', //常用用量
          doseUnit: minPackUnit || accountUnit, //常用用量单位 
          normalFrequency: '', //常用频次  
          useDays: 1, //常用天数 (1天)
          minPackNums: 1, //最小包装数量1
          minPackUnit: 'g', //包装单位为g
          accountUnit: 'g',//最小包装数量是g
        })
        setComponentItem({
          ...componentItem,
          billingCategory: '03', //开票项目 (中草药)
        })
        break
      case '中成药':
        setZYCYPshow(false)
        setUnitInfo({
          ...unitInfo,
          componentsUnit: '',
          capacityUnit: '',
          minPackUnit: '', //包装单位为g
          accountUnit: '',//最小包装数量是g
        })
        form.setFieldsValue({
          otc: 1,
          billingCategory: '02', //开票项目 (中成药)
          normalDose: '',
          doseUnit: minPackUnit,
          normalFrequency: '',
          useDays: '',
          components: '',
          componentsUnit: '',
          capacity: '',
          capacityUnit: '',
          minPackNums: '',
          minPackUnit: '',
          accountUnit: '',
        })
        setComponentItem({
          ...componentItem,
          billingCategory: '02', //开票项目 (中成药)
        })
        break
      default:
        setZYCYPshow(false)
        setUnitInfo({
          ...unitInfo,
          componentsUnit: '',
          capacityUnit: '',
          minPackUnit: '', //包装单位为g
          accountUnit: '',//最小包装数量是g
        })
        form.setFieldsValue({
          otc: 1,
          billingCategory: '01', //开票项目 (西药)
          normalDose: '',
          doseUnit: minPackUnit,
          normalFrequency: '',
          useDays: '',
          components: '',
          componentsUnit: '',
          capacity: '',
          capacityUnit: '',
          minPackNums: '',
          minPackUnit: '',
          accountUnit: '',
        })
        setComponentItem({
          ...componentItem,
          billingCategory: '01', //开票项目 (西药)
        })
        break
    }
  }

  // 药品分类选择对应的 药品标志要联动
  // const setDrugSymbol = (key: any) => {
  //   switch (key) {
  //     case '第一类精神药品':
  //       form.setFieldsValue({
  //         psychotropic1Tag: true,
  //       })
  //       break
  //     case '第二类精神药品(制剂)':
  //       form.setFieldsValue({
  //         psychotropic2Tag: true,
  //       })
  //       break
  //     case '麻醉药品':
  //       form.setFieldsValue({
  //         anaesthesiaTag: true,
  //       })
  //       break
  //     case '毒性药品':
  //       form.setFieldsValue({
  //         narcoticTag: true,
  //       })
  //       break
  //   }
  // }


  const getUseDaysNew = () => {
    const vs: any = form.getFieldsValue()
    const normalDose = Number(form.getFieldValue('normalDose')) //剂量
    const normalUsemethod = form.getFieldValue('normalUsemethod') //常用用法
    const normalFrequency = getNewNormalFrequencyCodeCalc(form.getFieldValue('normalFrequency')) || 0//频次
    const doseFixJDJZ = normalDose > 0 && normalUsemethod?.indexOf('静滴') >= 0 || normalDose > 0 && normalUsemethod?.indexOf('静注') >= 0 ? true : false
    const doseFixWH = normalDose > 0 && normalUsemethod?.indexOf('雾化') >= 0 ? true : false
    const flag = doseFixJDJZ ? settings?.[Checks?.SZYLJS] : settings?.[Checks?.WHYLJS]

    if (normalDose) {
      const useDays: any = getNewAutoChangePriceUseDays('', vs, vs?.doseUnit, doseFixJDJZ, doseFixWH, 1, normalFrequency, normalDose, flag)

      const realUseDays =
        useDays != 'Infinity'
          ? Math.floor(useDays < 1 ? 1 : useDays) || 1
          : 1

      form.setFieldsValue({
        useDays: realUseDays,
      })
    } else {
      notification.info({
        message: '请检查 常用用量/常用频次/规格是否填写完整'
      })
    }
  }

  // 剂量切换的overlay
  const overlay = (
    <Menu>
      <div
        className={styles.overlayContent}
        style={{ background: selectJL == '0' ? '#EBF4FF' : '#fff' }}
        onClick={() => {
          setIsVisible(false)
          setSelectJL('0')
        }}
      >
        <div>剂量 (成分含量)</div>
        <div style={{ color: '#666' }}>如：阿莫西林胶囊 0.5g*24粒/盒</div>
      </div>
      <div
        className={styles.overlayContent}
        style={{ background: selectJL == '1' ? '#EBF4FF' : '#fff' }}
        onClick={() => {
          setIsVisible(false)
          setSelectJL('1')
        }}
      >
        <div>剂量 (容量：成分含量)</div>
        <div style={{ color: '#666' }}>如：氨茶碱注射液 2ml:0.25mg*10支/盒</div>
      </div>
    </Menu>
  )

  // 商品标识码overlay
  const spbsmOverlay = (
    <Menu>
      <div
        className={styles.spbsmOverlayContent}>
        <div style={{ color: '#999999' }}>已关联 {drugMarkCCodeList?.length} 个</div>
      </div>
      {drugMarkCCodeList?.map((v: any) => {
        return (
          <div
            key={v}
            className={styles.spbsmOverlayContent}
            onClick={() => {
              return
            }}
          >
            <div>{v}</div>
            <div>
              <CloseOutlined
                style={{ color: '#999999' }}
                onClick={() => {
                  setDrugMarkCCodeList(
                    drugMarkCCodeList?.filter((item: any) => item != v)
                  )
                }}
              /></div>
          </div>
        )
      })}
    </Menu>
  )

  // 匹配重新匹配医保目录
  const recordPP = (item: any) => {
    getZjWbCodesAsync(item.hilistName)
    notification.success({ message: '匹配成功！' })
    setMedicalModalVisible(false)
  }

  // 五笔码回填
  const getZjWbCodesAsync = (item: any) => {
    dispatch(getZjWbCodes(item))
      .then(unwrapResult)
      .then((v: any) => {
        form.setFieldsValue({
          mnemonicCode: v?.pinYin,
          wubiCode: v?.wuBi,
        })
      })
  }

  // 注销或启用
  const setStateStatus = (id: any, status: boolean) => {
    const params = status ? {
      id: id, forceRemove: 1
    } : {
      id: id
    }
    dispatch(logoutOrenableCommodity(params))
      .then(unwrapResult)
      .then(() => {
        notification.success({ message: '操作成功' })
        history.push({
          pathname: '/storage/station',
          state: {
            station: '5',
          },
        })
      })
  }


  // 取消
  const returnMessage = () => {
    dispatch(setSelectId(0))
    dispatch(setCommodityDetail({}))
    if (props?.flag == '/homeFlag' || props?.flag == '/msfxFlag') {
      props?.refresh && props?.refresh()
    } else {
      history.push({
        pathname: '/storage/station',
        state: {
          station: '5',
        },
      })
    }
  }

  const scrollToTop = () => {
    setTimeout(() => {
      const leftBar = document.getElementById('sidebar') as HTMLElement
      if (leftBar) {
        leftBar.scrollTop = 0
      }
    }, 100)
  }

  const connectDrugMarkCode = (flag?: boolean) => {
    const value = YPBSMValue || form.getFieldValue('drugMarkCode')
    if (YPBSMValue?.length == 7 || YPBSMValue?.length == 14) {
      // 关联商品标识码
      if (
        !drugMarkCCodeList?.find(
          (d: any) => d == value
        )
      ) {
        setDrugMarkCCodeList(drugMarkCCodeList?.concat(value))
        form.setFieldsValue({ 'drugMarkCode': '' })
        setTimeout(() => {
          drugMarkCodeRef.current?.focus()
        }, 10)
      } else {
        setDrugMarkCCodeList(drugMarkCCodeList)
        form.setFieldsValue({ 'drugMarkCode': '' })
        // setTimeout(() => {
        //   drugMarkCodeRef.current?.focus()
        // }, 10)
      }
    } else {
      if (flag) return
      notification.info({
        message: '无效的识别码',
      })
    }
  }

  return (
    <>
      {props?.materialCategory?.toString() ? <></> : (
        <Col
          style={{
            margin: '10px 20px',
          }}
        >
          <NavBar
            where={[
              '商品目录',
              JSON.stringify(detail) !== '{}' ? getMaterialsName(materialCategory) + '修改' : getMaterialsName(materialCategory) + '新增',
            ]}
            backtrace={{
              name: '库房工作站',
              path: '/storage/station',
              state: {
                station: '5',
              },
              routeName: '库房工作站',
            }}
            buttons={<></>}
          />
        </Col>
      )}
      <div className={props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? styles.elseSaveform : styles.saveform}>
        <Form
          className={styles.formContent}
          {...layout}
          form={form}
          name='control-hooks'
          autoComplete='off'
          layout='vertical'
          onFinishFailed={(v) => {
            if (v?.errorFields?.length) {
              notification.error({
                message: '请输入必填项',
              })
              scrollToTop()
            }
          }}
          onFinish={(vs) => {
            const drugCategory = YPdata?.find((v) => v.id === vs.drugCategory)?.name || vs.drugCategory
            const commonParmas = {
              source,
              sourceMaterialsCatalogId,
              tenantSupplierId,
              drugCategory: drugCategory, //类别
              otc: vs.otc || 0, //otc
              doseUnit: vs?.doseUnit || '',
              useDays: vs?.useDays ? vs?.useDays : -1, //使用天数
              splitTag: vs.splitTag ? 1 : 0, //允许拆零
              anaesthesiaTag: vs.anaesthesiaTag ? 1 : 0,//毒药物
              narcoticTag: vs.narcoticTag ? 1 : 0, //是否麻醉药物
              psychotropic1Tag: vs.psychotropic1Tag ? 1 : 0, //是否精一药物
              psychotropic2Tag: vs.psychotropic2Tag ? 1 : 0, //是否精二药物
              stimulantTag: vs.stimulantTag ? 1 : 0, //兴奋类
              ephedrineTag: vs.ephedrineTag ? 1 : 0, //麻黄碱
              antibioticTag: vs.antibioticTag ? 1 : 0, //抗生素
              basicMedicineTag: vs.basicMedicineTag ? 1 : 0, //基药
              skinTestTag: vs.skinTestTag ? 1 : 0,//皮试标志 

              splitPrice: vs.splitPrice ? vs.splitPrice : 0, //拆零售价/元
              retailPrice: tenantCategory == 17 ? 0 : vs.retailPrice, //售价/元
              drugMarkCode: form.getFieldValue('noTraceCodeFlag') == '1' ? '' : drugMarkCCodeList?.join(',') || '', //商品标识码
              allowUseUserId: vs?.allowUseUserId?.join(','), //限定开单医生
              forceYearAccount: vs.forceYearAccount ? vs.forceYearAccount : 0, //医保结算方式
              qualityControlCategory: vs.qualityControlCategory ?? '', //质量管理分类
              putCategory: vs.putCategory ?? '', //存储分类

              // 预警与库存设置字段
              ageReminder: undefined,
              judgmentType: undefined,
              ageLimit: undefined,
              genderReminder: undefined,
              gender: undefined,

              // 新增的六个字段
              capacity: undefined, //容量
              capacityUnit: undefined, //容量单位
              components: undefined, //成分含量
              componentsUnit: undefined, //成分含量单位
              minPackUnit: undefined, //最小包装单位
              minPackNums: undefined, //最小包装数量
              // 原有但现在页面不展示的字段
              natNegoDrugFlag: vs.natNegoDrugFlag ? 1 : 0,
              splitScale: vs.splitScale ? vs.splitScale : 0,
              // inventoryAlertType: vs?.inventoryAlertType ? 1 : 0, //不分批次

              // 医保信息
              hilistName: medicalModalInfo?.hilistName, //医保名称
              hiListCode: medicalModalInfo?.hiListCode, //医保代码
              chrgitmLv: medicalModalInfo?.chrgitmLv, //甲乙分类
              // hiListSpec: medicalModalInfo?.hiListSpec, //医保规格
              // prodentpName: medicalModalInfo?.prodentpName, //医保厂家
              // hilistPricUplmtAmt: medicalModalInfo?.hilistPricUplmtAmt, //医保限价
              // pacmatl : medicalModalInfo?.pacmatl, //包装材质
              // pacUnit: medicalModalInfo?.pacUnit, //医保单位
              // memo: medicalModalInfo?.memo, //医保备注
            }
            const saveMappingBody = {
              proviceHilistCode: vs.proviceHilistCode,
              limitCount: vs.limitCount,
              billing_category: vs.billingCategory || '',
              hilist_code: vs.hiListCode || '',
              insuranceCode: insuranceArray[0]?.insuranceCode || '',
              is_reimbursement: medicalModalInfo?.isCouldBx || '',
              limitId: medicalModalInfo?.limitId || detail?.limitId || '',
              rid: medicalModalInfo?.rid,
            }

            const materialsCatalogPlus = {
              capacity: vs.capacity, //容量
              capacityUnit: vs.capacityUnit, //容量单位
              components: vs.components, //成分含量
              componentsUnit: vs.componentsUnit, //成分含量单位
              minPackUnit: vs.minPackUnit, //最小包装单位
              minPackNums: vs.minPackNums, //最小包装数量
              isCapacity: selectJL == '1' ? 1 : 0, //是否分类
            }

            const memberInterestVO = tenantCategory == 1 ? {
              discountType: vs.discountType,
              price: vs.memberPrice,
            } : {}

            if (vs.minPackUnit == vs.accountUnit && vs.minPackNums != 1) {
              Modal.warning({
                centered: true,
                title: '提示',
                content: '格式错误，最小包装数量不为1时，包装单位和最小包装单位不能相同',
                okText: '知道了',
                icon: <ExclamationCircleFilled style={{ color: '#faad14' }} />,
              })
              return
            }            
            
            const params = selectId
              ? {
                materialsCatalog: {
                  ...vs,
                  ...commonParmas,
                  tax: vs?.tax ? vs?.tax : '',
                  id: selectId,
                  rules: {
                    ageReminder: vs?.ageReminder ? 1 : 0,
                    judgmentType: vs?.judgmentType,
                    ageLimit: vs?.ageLimit,
                    genderReminder: vs?.genderReminder ? 1 : 0,
                    gender: vs?.gender > 0 ? Number(vs?.gender) : '',
                  },
                  memberInterestVO: memberInterestVO,
                },
                saveMappingBody: saveMappingBody,
                materialsCatalogPlus: materialsCatalogPlus,
              }
              : {
                materialsCatalog: {
                  ...vs,
                  ...commonParmas,
                  rules: {
                    ageReminder: vs?.ageReminder ? 1 : 0,
                    judgmentType: vs?.judgmentType,
                    ageLimit: vs?.ageLimit,
                    genderReminder: vs?.genderReminder ? 1 : 0,
                    gender: vs?.gender > 0 ? Number(vs?.gender) : '',
                  },
                  memberInterestVO: memberInterestVO,
                },
                saveMappingBody: saveMappingBody,
                materialsCatalogPlus: materialsCatalogPlus,
              }
            setIsSubmitLoading(true)
            dispatch(saveCommodityAsync({ ...params }))
              .then(unwrapResult)
              .then((v: any) => {
                dispatch(setSelectId(0))
                dispatch(setCommodityDetail({}))
                // 保存并继续
                if (saveAndContinue) {
                  const billingCategory = form.getFieldValue('billingCategory')
                  const drugCategory = form.getFieldValue('drugCategory')
                  resetForm()
                  // 获取药品编码
                  dispatch(getShopGoodsNo())
                  form.setFieldsValue({
                    billingCategory: billingCategory,
                    drugCategory: drugCategory,
                    materialsCategory: materialCategory,
                  })
                } else {
                  if (props?.flag == '/homeFlag' || props?.flag == '/msfxFlag') {
                    props?.refresh && props?.refresh({ ...vs, ...commonParmas, materialsCatalogId: v?.materialsCatalogId })
                  } else {
                    history.push({
                      pathname: '/storage/station',
                      state: {
                        station: '5',
                      },
                    })
                  }
                }
              })
              .finally(() => {
                setIsSubmitLoading(false)
              })
          }}
        >
          {/* 码上放心发货单展示信息 */}
          {props?.flag == '/msfxFlag' && JSON.stringify(props?.details) !== '{}' ?
            <Row style={{ position: 'relative', top: '0px', left: '0px', marginBottom: '4px' }}>
              <Col span={24} style={{ width: '100%', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
                <span style={{ marginRight: '6px' }}>码上放心发货单</span>
                <span>商品名称：{props?.details?.name}，</span>
                <span>通用名：{props?.details?.genericName}，</span>
                <span>包装规格：{props?.details?.packSpec}，</span>
                <span>批准文号：{props?.details?.approvalNumber}，</span>
                {/* <span>转换比：{props?.details?.transitionScale}，</span> */}
                <span>生产厂家：{props?.details?.tenantSupplierName}</span>
              </Col>
            </Row>
            : ''
          }
          {/* 快捷创建商品 */}
          {JSON.stringify(detail) !== '{}' || selectId ?
            <></> :
            <Col span={15} style={{ display: 'flex' }}>
              <Col className={styles.creatShop}>快捷创建商品</Col>
              <Col
                span={insuranceArray?.length ? 19 : 21}
                style={{ display: 'flex', alignContent: 'center' }}
              >
                <Form.Item
                  {...titleColumnLayout}
                  name='allStr'
                  label=''
                  wrapperCol={{
                    span: 24,
                  }}
                  style={{ width: '100%' }}
                >
                  <RecipeItemInput
                    materialsCategory={materialCategory}
                    source={source}
                    type={ItemCompletionType.Auto}
                    filters={false}
                    defaultUsingSpecifiedBatch={false}
                    onSelect={(m: any) => {
                      setTenantSupplierId(tenantSupplierId)
                      setSourceMaterialsCatalogId(m.id)
                      setSplitTag(false)
                      getZjWbCodesAsync(m.name)
                      recipeItemInputSetFileds(m)
                    }}
                  />
                </Form.Item>
                {JSON.stringify(props?.details) != '{}' ? <></> : open && (
                  <Popconfirm
                    title='扫条形码 (69码) 快速添加商品'
                    placement='right'
                    disabled
                    visible={open}
                    onConfirm={() => setOpen(false)}
                    showCancel={false}
                    icon={<CheckCircleOutlined />}
                    okText='我知道了'
                  >
                    <div style={{ marginTop: 15 }}></div>
                  </Popconfirm>
                )}
              </Col>
              {insuranceArray?.length ? (
                <Col style={{ marginLeft: 10 }}>
                  <Button
                    type='primary'
                    ghost
                    style={{ float: 'left' }}
                    onClick={() => {
                      setWriteBack(true)
                      setMedicalModalVisible(true)
                      setComponentItem({
                        name: '',  //商品名称
                        billingCategory: '01', //开票项目 (西药)
                        tenantSupplierName: '', //生产厂家
                        approvalNumber: '', //批准文号
                      })
                    }}
                  >
                    从医保目录搜索
                  </Button>
                </Col>) : <></>}
              {/* <Col >
              <div className={styles.settingFZ}>
                <SettingOutlined
                  style={{
                    fontSize: '20px',
                    color: '#027AFF',
                  }}
                />
                <span className={styles.settingFZText}>赋值设置</span>
              </div>
            </Col> */}
            </Col>}

          {/* 中心内容 */}
          <Row className={styles.centerContent}>
            {/* 左侧内容 */}
            <Col span={tenantCategory == 17 ? 24 : 15} className={props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? styles.elseLeftContent : JSON.stringify(detail) !== '{}' ? styles.noSearchleftContent : styles.leftContent} id='sidebar'>
              <div className={styles.titleText}> 商品基本信息</div>
              <Row>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='no'
                    label='商品编码'
                    rules={[
                      { required: true },
                      {
                        pattern: new RegExp(/^[0-9a-zA-Z]{1,}$/, 'g'),
                        message: '请输入数字或字母',
                      },
                      {
                        max: 20,
                        message: '最长20位',
                      },
                    ]}
                  >
                    <Input
                      size='middle'
                      allowClear
                      disabled={selectId ? true : false}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='name'
                    label='通用名'
                    rules={[{ required: true }, { max: 45, message: '最长45位!' }]}
                  >
                    <Input
                      autoFocus
                      size='middle'
                      allowClear
                      onInput={(e: any) => {
                        getWubi(e.target.value)
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='genericName'
                    label='商品名'
                    rules={[{ max: 45, message: '最长45位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label='类别'
                    {...firstColumnLayout}
                  >
                    <Row className={styles.hbCol}>
                      <Col span={9}>
                        <Form.Item name='materialsCategory' >
                          <Select placeholder='' allowClear disabled>
                            {Materiales.map((v) => (
                              <Option value={v} key={v}>
                                {getMaterialsName(v)}
                              </Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={15}>
                        <Form.Item name='drugCategory'>
                          <Select
                            allowClear={false}
                            onChange={(key) => {
                              setOTCBILL(key)
                              setDoseUnitChange(false)
                            }}
                            getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          >
                            {YPdata.map((s) => (
                              <Select.Option key={s.name} value={s.name}>
                                {s.name}
                              </Select.Option>
                            ))}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='billingCategory'
                    label='开票项目'
                    rules={[{ required: true }]}
                  >
                    <Select
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      placeholder=''
                      allowClear={false}
                      onChange={(e) => {
                        getBillingCategoryChange(e)
                      }}
                    >
                      {InvoiceBillingCategories.map((v) => {
                        return (
                          <Option value={v} key={v}>
                            {BillingCategoryName(v)}
                          </Option>
                        )
                      })}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='approvalNumber'
                    label='批准文号'
                    rules={[{ max: 128, message: '最长128位!' }]}
                  >
                    <Input
                      size='middle'
                      allowClear
                      onChange={(e: any) => {
                        setComponentItem({
                          ...componentItem,
                          approvalNumber: e?.target?.value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='doseCategory'
                    label='剂型'
                  >
                    <RecipeItemFieldInput
                      clearDataFlag={false}
                      field={'doseCategory'}
                      disabled={false}
                      noSize={true}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='tenantSupplierName'
                    label='生产厂家'
                    rules={[{ required: true }]}
                  >
                    <Input
                      size='middle'
                      allowClear
                      onClick={() => {
                        setFlag(1)
                        setIsModalVisible(true)
                      }}
                      onChange={(e: any) => {
                        setComponentItem({
                          ...componentItem,
                          tenantSupplierName: e?.target?.value,
                        })
                        // 回填上市许可持有人
                        form.setFieldsValue({
                          lstdLicHolder: e?.target?.value,
                        })
                      }}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='lstdLicHolder' label='上市许可持有人'>
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                {/* 中药材/饮片不展示剂量 */}
                {!ZYCYPshow ?
                  <Col span={8}>
                    <Dropdown
                      overlay={overlay}
                      visible={isVisible}
                      onVisibleChange={(v) => {
                        if (!v) {
                          setIsVisible(v);
                        }
                      }}
                    >
                      <Col className={styles.jlTitle}>
                        <span
                          onClick={() => {
                            setIsVisible(!isVisible);
                          }}>{selectJL == '0' ? '剂量 (成分含量)' : '剂量 (容量：成分含量)'}</span>
                        <CaretDownFilled
                          style={{ color: '#999999', marginLeft: '4px' }}
                          onClick={() => {
                            setIsVisible(!isVisible);
                          }} />
                      </Col>
                    </Dropdown>
                    <Form.Item>
                      {selectJL == '0' ?
                        <Row className={styles.hbCol}>
                          <Col span={14}>
                            {/* 成分含量 */}
                            <Form.Item
                              name='components'
                              rules={[{
                                pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,5})?$/),
                                message: '请输入数字，支持小数点后5位',
                              }]}
                            >
                              <Input
                                size='middle'
                                allowClear
                                onPressEnter={() => {
                                  componentsUnitRef.current?.focus()
                                }} />
                            </Form.Item>
                          </Col>
                          <Col span={10}>
                            {/* 成分含量单位 */}
                            <Form.Item
                              name='componentsUnit'
                            >
                              <RecipeItemFieldInput
                                ref={componentsUnitRef}
                                placeholderInput='单位'
                                clearDataFlag={false}
                                field={'doseUnit'}
                                disabled={false}
                                noSize={true}
                                onChange={(res) => {
                                  setUnitInfo({
                                    ...unitInfo,
                                    componentsUnit: res,
                                  })
                                }}
                                onPressEnter={() => {
                                  minPackNumsRef.current?.focus()
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row> :
                        <Row className={styles.hbCol}>
                          <Col span={6}>
                            {/* 容量 */}
                            <Form.Item
                              name='capacity'
                              rules={[{
                                pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,5})?$/),
                                message: '请输入数字，支持小数点后5位',
                              }]}
                            >
                              <Input
                                size='middle'
                                allowClear
                                onPressEnter={() => {
                                  capacityUnitRef.current?.focus()
                                }} />
                            </Form.Item>
                          </Col>
                          <Col span={5}>
                            {/* 容量单位 */}
                            <Form.Item
                              name='capacityUnit'
                            >
                              <RecipeItemFieldInput
                                ref={capacityUnitRef}
                                placeholderInput='单位'
                                clearDataFlag={false}
                                field={'doseUnit'}
                                disabled={false}
                                noSize={true}
                                onChange={(res) => {
                                  setUnitInfo({
                                    ...unitInfo,
                                    capacityUnit: res,
                                  })
                                }}
                                onPressEnter={() => {
                                  componentsRef.current?.focus()
                                }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={2} className={styles.flexCenter}> : </Col>
                          <Col span={6}>
                            {/* 成分含量 */}
                            <Form.Item
                              name='components'
                              rules={[{
                                pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,5})?$/),
                                message: '请输入数字，支持小数点后5位',
                              }]}
                            >
                              <Input
                                size='middle'
                                allowClear
                                ref={componentsRef}
                                onPressEnter={() => {
                                  componentsUnitRef.current?.focus()
                                }} />
                            </Form.Item>
                          </Col>
                          <Col span={5}>
                            {/* 成分含量单位 */}
                            <Form.Item
                              name='componentsUnit'
                            >
                              <RecipeItemFieldInput
                                ref={componentsUnitRef}
                                placeholderInput='单位'
                                clearDataFlag={false}
                                field={'doseUnit'}
                                disabled={false}
                                noSize={true}
                                onChange={(res) => {
                                  setUnitInfo({
                                    ...unitInfo,
                                    componentsUnit: res,
                                  })
                                }}
                                onPressEnter={() => {
                                  minPackNumsRef.current?.focus()
                                }}
                              />
                            </Form.Item>
                          </Col>
                        </Row>}
                    </Form.Item>
                  </Col> : <></>}
                <Col span={8} className={styles.hbCol} style={{ position: 'relative' }}>
                  <div className={styles.unitIcon}> * </div>
                  <Form.Item
                    label='最小包装数量 ｜ 单位'
                    // 中药如果勾选拆零：则包装规格里的最小包装数量 ｜ 单位 也要为必填
                    required={ZYCYPshow ? ((ZYCYPshow && splitTag) ? true : false) : true}
                    rules={[
                      { required: true },
                    ]}
                  >
                    <Row>
                      <Col span={14}>
                        {/* 最小包装数量 */}
                        <Form.Item
                          {...firstColumnLayout}
                          name='minPackNums'
                          rules={[
                            { required: ZYCYPshow ? ((ZYCYPshow && splitTag) ? true : false) : true, message: '请输入最小包装数量' },
                            {
                              pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                              message: '请输入数字',
                            },
                          ]}
                        >
                          <Input
                            ref={minPackNumsRef}
                            size='middle'
                            allowClear
                            onChange={(e: any) => {
                              return
                            }}
                            onPressEnter={() => {
                              minPackUnitRef.current?.focus()
                            }}
                          />
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        {/* 最小包装单位 */}
                        <Form.Item
                          name='minPackUnit'
                          rules={[{ required: ZYCYPshow ? ((ZYCYPshow && splitTag) ? true : false) : true, message: '请选择单位' }]}
                        >
                          <RecipeItemFieldInput
                            ref={minPackUnitRef}
                            placeholderInput='单位'
                            clearDataFlag={false}
                            field={'doseUnit'}
                            disabled={false}
                            noSize={true}
                            onChange={(res) => {
                              setUnitInfo({
                                ...unitInfo,
                                minPackUnit: res,
                              })
                              // （常用用量单位）非中药默认选中最小包装单位
                              if (!doseUnitChange && JSON.stringify(detail) == '{}') {
                                isAutoSettingDoseUnitRef.current = true
                                form.setFieldsValue({
                                  doseUnit: res,
                                })
                                isAutoSettingDoseUnitRef.current = false
                              }
                            }}
                            onPressEnter={() => {
                              accountUnitRef.current?.focus()
                            }}
                          />
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Row style={{ position: 'relative' }}>
                    <div className={styles.unitIconCHU}> / </div>
                    <Col span={14}>
                      <Form.Item
                        {...firstColumnLayout}
                        name='accountUnit'
                        label='包装单位' //对应老的账簿单位
                        rules={[{ required: true, message: '请选择包装单位' }]}
                      >
                        <RecipeItemFieldInput
                          ref={accountUnitRef}
                          clearDataFlag={false}
                          field={'accountUnit'}
                          disabled={false}
                          noSize={true}
                          onChange={(res) => {
                            setUnitInfo({
                              ...unitInfo,
                              accountUnit: res,
                            })
                            // （常用用量单位）没有修改 doseUnitChange 过的情况下 中药 ZYCYPshow 默认选中最小包装单位 minPackUnit，没有再包装单位
                            const minPackUnit = form.getFieldValue('minPackUnit')
                            if (!doseUnitChange && !minPackUnit && ZYCYPshow && JSON.stringify(detail) == '{}') {
                              isAutoSettingDoseUnitRef.current = true
                              form.setFieldsValue({
                                doseUnit: res,
                              })
                              isAutoSettingDoseUnitRef.current = false
                            }
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Popover
                      title='示例'
                      content={
                        <div>
                          <img
                            src={ZYCYPshow ? DrugImg2 : selectJL == '1' ? DrugImg3 : DrugImg1}
                            style={{ width: '500px' }}
                            alt=''
                          />
                        </div>
                      }
                      placement='bottom'
                    >
                      <Col span={10} className={styles.bzdwTips}>查看示例</Col>
                    </Popover>
                  </Row>

                </Col>
                {ZYCYPshow ?
                  <Col span={8}></Col> : <></>}
                {/* 中药方不展示常用频次 */}
                {!ZYCYPshow ?
                  <Col span={8}>
                    <Form.Item
                      {...firstColumnLayout}
                      name='normalFrequency'
                      label='常用频次'
                    >
                      <RecipeItemFieldInput
                        clearDataFlag={false}
                        field={'normalFrequency'}
                        disabled={false}
                        noSize={true}
                      />
                    </Form.Item>
                  </Col> : <></>}

                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='normalUsemethod'
                    label='常用用法'
                  >
                    <RecipeItemFieldInput
                      clearDataFlag={true}
                      recipeCategory={
                        ZYCYPshow ? 3 : 1
                      }
                      field={'normalUsemethod'}
                      disabled={false}
                      noSize={true}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label='常用用量'>
                    <Row>
                      <Col span={14}>
                        <Form.Item
                          name='normalDose'
                          rules={[
                            {
                              pattern: new RegExp(/^([0-9]+(\.[0-9]{1,5})?)$/, 'g'),
                              message: '请输入保留小数5位以内的数',
                            },
                          ]}
                        >
                          <Input allowClear disabled={selectDoseUnit == '适量'} />
                        </Form.Item>
                      </Col>
                      <Col span={10}>
                        <Form.Item name='doseUnit'>
                          <Select
                            placeholder='单位'
                            allowClear
                            onClear={() => {
                              setDoseUnitChange(true)
                              form.setFieldsValue({
                                doseUnit: '',
                              })
                            }}
                            // 自己修改过单位后最新包装单位改变时就不会改变了 
                            onChange={((v) => {
                              if (!isAutoSettingDoseUnitRef.current) {
                                setDoseUnitChange(true)
                              }
                              setSelectDoseUnit(v)
                              if (v == '适量') {
                                form.setFieldsValue({
                                  normalDose: '',
                                })
                              }
                            })}>
                            {doseUnitData?.map((v: any) => {
                              return (
                                <Option value={v?.name} key={v?.name}>
                                  {v?.name}
                                </Option>
                              )
                            })}
                          </Select>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8} className={styles.addonAfterButton}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='useDays'
                    label='用药天数'
                    rules={[
                      {
                        pattern: new RegExp(/^[1-9]\d*$/, 'g'),
                        message: '请输入数字',
                      },
                    ]}
                  >
                    <Input
                      size='middle'
                      allowClear
                      addonAfter={
                        <>
                          <Button
                            type='primary'
                            ghost
                            onClick={(() => {
                              getUseDaysNew()
                            })}>自动计算天数</Button>
                        </>
                      }
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='barCode'
                    label='条形码'
                    rules={[
                      {
                        pattern: new RegExp(/^[0-9a-zA-Z]{1,}$/, 'g'),
                        message: '请输入数字或字母',
                      },
                      { max: 35, message: '最长35位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ position: 'relative' }}>
                  <Form.Item
                    label='商品标识码(追溯码前7位)'
                    {...firstColumnLayout}
                  >
                    <Row className={styles.hbCol}>
                      <Col span={7}>
                        <Form.Item name='noTraceCodeFlag'>
                          <Select placeholder='' >
                            <Option value={'0'} key={'0'}>
                              有码
                            </Option>
                            <Option value={'1'} key={'1'}>
                              无码
                            </Option>
                          </Select>
                        </Form.Item>
                      </Col>
                      <Col span={17} className={styles.addonAfterButton} style={{ position: 'relative' }}>
                        <Dropdown
                          overlay={spbsmOverlay}
                          visible={isSPBSMVisible}
                          onVisibleChange={(v) => {
                            if (!v) {
                              setIsSPBSMVisible(v);
                            }
                          }}
                        >
                          <Form.Item
                            name='drugMarkCode'
                            rules={[
                              {
                                pattern: new RegExp(/^[a-zA-Z0-9,]*$/, 'g'),
                                message: '请输入数字或字母',
                              },
                            ]}>
                            <Input
                              ref={drugMarkCodeRef}
                              placeholder={drugMarkCCodePlaceholder}
                              size='middle'
                              allowClear={false}
                              maxLength={50}
                              addonAfter={
                                <>
                                  {showGLButton && (
                                    <Button
                                      type='primary'
                                      ghost
                                      onClick={(() => {
                                        connectDrugMarkCode(true)
                                      })}
                                    >关联</Button>)
                                  }
                                </>
                              }
                              onFocus={() => {
                                // 光标选中展示placeholder
                                setDrugMarkCCodePlaceholder('扫描或输入前7位')
                              }}
                              onBlur={() => {
                                // 失焦不展示placeholder
                                setDrugMarkCCodePlaceholder('')
                                connectDrugMarkCode()
                                form.setFieldsValue({
                                  drugMarkCode: drugMarkCCodeList?.[0]
                                })
                              }}
                              onPressEnter={(() => {
                                connectDrugMarkCode()
                              })}
                              onClick={() => {
                                // 点击输入框展示弹窗
                                if (drugMarkCCodeList?.length) {
                                  setIsSPBSMVisible(true)
                                  form.setFieldsValue({
                                    drugMarkCode: ''
                                  })
                                }
                              }}
                              onChange={((e) => {
                                const value = e?.target?.value
                                setYPBSMValue(value)
                                if (value) {
                                  // 输入中展示关联按钮
                                  setShowGLButton(true)
                                } else {
                                  // 输入为空不展示关联按钮
                                  setShowGLButton(false)
                                }
                              })}
                            /></Form.Item>
                        </Dropdown>
                        {(drugMarkCCodeList?.length && drugMarkCCodeList?.length > 1 && !showGLButton) ? (
                          <span style={{ color: '#07C160', position: 'absolute', right: '12px', top: '5px' }}>
                            +{drugMarkCCodeList?.length - 1}
                          </span>
                        ) : ''}
                      </Col>
                    </Row>
                  </Form.Item>
                  <Popover
                    title='药品标识码'
                    content={
                      <div>
                        <p>
                          药品标志码为药品追溯码的前一部分代码，当您维护此编码后，系统会在上传追溯码时为您校验
                          <span style={{ fontWeight: 'bold' }}>
                            是否扫错码
                          </span>
                          。
                        </p>
                        <p>一般情况下</p>
                        <p>
                          追溯码为
                          <span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            20位
                          </span>
                          的药品，药品标志码为
                          <span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            前7位
                          </span>
                        </p>
                        <p>
                          <span
                            style={{ color: '#d33f0e', fontWeight: 'bold' }}
                          >
                            超过20位
                          </span>
                          的长追溯码（部分进口药），药品标志码为
                          <span
                            style={{ color: '#d33f0e', fontWeight: 'bold' }}
                          >
                            前14位
                          </span>
                        </p>
                        <p>
                          如果同个品种存在多个标识码，可以用英文逗号隔开。您可以不用手动填写此代码，<span
                            style={{ color: '#068b39', fontWeight: 'bold' }}
                          >
                            系统将在你扫码时自动更新该信息。
                          </span>
                        </p>
                        <p>
                          <img
                            src={DrugImg}
                            style={{ width: '300px' }}
                            alt=''
                          />
                        </p>
                        <p>有码无码：如果药品包装上无追溯码，可将该药品标记为“无码药品”，发药、入库时无需扫码采集。医保监管要求应采尽采，药品有追溯码但设置成无码，可能会存在监管处罚风险。</p>
                      </div>
                    }
                    placement='bottom'
                  >
                    <span className={styles.tips}>示例</span>
                  </Popover>
                </Col>
                {/* 中药材/饮片展示复方标志 */}
                {ZYCYPshow ? (
                  <>
                    <Col span={8}>
                      <Form.Item
                        {...firstColumnLayout}
                        name='compoundTag'
                        label='复方标志'
                      >
                        <Select
                          getPopupContainer={(triggerNode) => triggerNode.parentNode}
                          placeholder='复方标志'
                          allowClear={false}
                        >
                          <Option value={0}>非草药</Option>
                          <Option value={1}>单味</Option>
                          <Option value={2}>复方</Option>
                        </Select>
                      </Form.Item>
                    </Col>
                  </>
                ) : (
                  <></>
                )}
                {/* 中药材/饮片不展示展示OTC分类 */}
                {!ZYCYPshow ? (
                  <Col span={8}>
                    <Form.Item
                      {...firstColumnLayout}
                      name='otc'
                      label='OTC分类'
                    >
                      <Select
                        getPopupContainer={(triggerNode) => triggerNode.parentNode}
                        placeholder=''
                        allowClear={false}
                      >
                        {OtcCategories.map((v) => {
                          return (
                            <Option value={v} key={v}>
                              {getOtcCategoryName(v)}
                            </Option>
                          )
                        })}
                      </Select>
                    </Form.Item>
                  </Col>
                ) : (
                  <></>
                )}
                <Col span={8}>
                  <Form.Item
                    name='maintainCategory'
                    label='养护等级'
                    {...firstColumnLayout}
                  >
                    <Select
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      placeholder=''
                    >
                      <Option value={0}>一般养护</Option>
                      <Option value={1}>重点养护</Option>
                    </Select>
                  </Form.Item>
                </Col>
              </Row>
              <div className={styles.titleTexts}>
                <span style={{ fontWeight: 'bold' }}>扩展信息</span>
                <span
                  className={styles.iconMain}
                  onClick={() => {
                    setExtendInformation(!extendInformation)
                  }}
                >
                  <span>{!extendInformation ? '展开' : '收起'}</span>
                  {!extendInformation ? (
                    <CaretDownFilled className={styles.icon} />
                  ) : (
                    <CaretUpFilled className={styles.icon} />
                  )}
                </span>
              </div>
              <Row style={{ display: extendInformation ? undefined : 'none' }}>
                <Col span={24} >
                  <Form.Item
                    label='药品标志'
                    {...firstColumnLayout}
                    style={{ marginBottom: 0 }}
                  >
                    <Row className={styles.hbCol}>
                      <Col span={3}>
                        <Form.Item name='psychotropic1Tag' valuePropName='checked'>
                          <Checkbox>精一</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item name='psychotropic2Tag' valuePropName='checked'>
                          <Checkbox>精二</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item name='anaesthesiaTag' valuePropName='checked'>
                          <Checkbox>毒性</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item name='narcoticTag' valuePropName='checked'>
                          <Checkbox>麻醉</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item name='ephedrineTag' valuePropName='checked'>
                          <Checkbox>麻黄碱</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item name='antibioticTag' valuePropName='checked'>
                          <Checkbox>抗生素</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item name='stimulantTag' valuePropName='checked'>
                          <Checkbox>兴奋类</Checkbox>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item name='basicMedicineTag' valuePropName='checked'>
                          <Checkbox>基药</Checkbox>
                        </Form.Item>
                      </Col>
                    </Row>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='skinTestTag'
                    label='皮试标志'
                  >
                    <Select
                      placeholder='请选择'
                    >
                      <Option value={1} key={1}>
                        需要皮试
                      </Option>
                      <Option value={0} key={0}>
                        无需皮试
                      </Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8} style={{ position: 'relative' }}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='mnemonicCode'
                    label='助记码'
                    rules={[
                      {
                        max: 40,
                        message: '最长40位!',
                      },
                    ]}
                  >
                    <Input
                      size='middle'
                      allowClear
                    />
                  </Form.Item>
                  <Popover
                    content={
                      <div>
                        <p>
                          是指通用名的拼音首字母，系统自动生成，设置后支持用助记码去搜索该商品
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips3} />
                  </Popover>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='wubiCode'
                    label='五笔码'
                    rules={[
                      {
                        max: 40,
                        message: '最长40位!',
                      },
                    ]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='origin' label='产地' {...firstColumnLayout}>
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='putCategory' label='存储分类'>
                    <Select
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      allowClear
                    >
                      {qualityControlCategories.map((v) => (
                        <Option value={v} key={v}>
                          {getQualityControlCategory(v)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='freezeTemperature'
                    label='冷藏温度'
                    rules={[{ max: 45, message: '最长45位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ position: 'relative' }}>
                  <Form.Item
                    {...firstColumnLayout}
                    name='miscNo'
                    label='第三方编号'
                    rules={[{ max: 45, message: '最长45位!' }]}
                  >
                    <Input
                      size='middle'
                      allowClear
                    />
                  </Form.Item>
                  <Popover
                    content={
                      <div>
                        <p>
                          主要用于购入入库导入库存时导入的商品和目录做关联。
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips5} />
                  </Popover>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='cabineNo'
                    label='柜号'
                    rules={[{ max: 45, message: '最长45位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8} style={{ position: 'relative' }}>
                  <Form.Item name='normalGysName' label='常用供应商'>
                    <Input
                      size='middle'
                      allowClear
                      onClick={() => {
                        setFlag(0)
                        setIsModalVisible(true)
                      }}
                    />
                  </Form.Item>
                  <Popover
                    content={
                      <div>
                        <p>
                          设置常用供应商后，您可以通过入库/申领/采购等环节设置的供应商快速找到这个药品。
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips5} />
                  </Popover>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='reportNo'
                    label='报告书标号/通关单号'
                    rules={[{ max: 45, message: '最长45位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item name='qualityControlCategory' label='质量管理分类'>
                    <Select
                      getPopupContainer={(triggerNode) => triggerNode.parentNode}
                      allowClear
                    >
                      {inventoryAlertCate.map((v) => (
                        <Option value={v} key={v}>
                          {getinventoryAlertName(v)}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    name='productionLicence'
                    label='生产许可证'
                    rules={[{ max: 128, message: '最长128位!' }]}
                  >
                    <Input size='middle' allowClear />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <Form.Item name='remark' label='备注' {...remarkColumnLayout}>
                    <TextArea size='middle' showCount maxLength={200} style={{ width: '97.4%' }} />
                  </Form.Item>
                </Col>
              </Row>
              <div className={styles.titleTexts}>
                <span style={{ fontWeight: 'bold' }}>预警与库存设置</span>
                <span
                  className={styles.iconMain}
                  onClick={() => {
                    setYJYKCSetting(!YJYKCSetting)
                  }}
                >
                  <span>{!YJYKCSetting ? '展开' : '收起'}</span>
                  {!YJYKCSetting ? (
                    <CaretDownFilled className={styles.icon} />
                  ) : (
                    <CaretUpFilled className={styles.icon} />
                  )}
                </span>
              </div>
              <Row style={{ display: YJYKCSetting ? undefined : 'none' }}>
                <Col span={16}>
                  <Col className={styles.jlTitle}>
                    <span>开方性别限制</span>
                  </Col>
                  <Col style={{ display: 'flex' }}>
                    <Col span={1}>
                      <Form.Item
                        name='genderReminder'
                        valuePropName='checked'
                      >
                        <Checkbox
                          onChange={(v) => {
                            setGenderReminderFlag(v?.target.checked)
                          }}
                        />
                      </Form.Item>
                    </Col>
                    {genderReminderFlag ?
                      <Col span={12} style={{ display: 'flex' }}>
                        <div style={{ marginTop: '5px' }}>仅限</div>
                        <Form.Item
                          name='gender'
                          rules={[{ required: true, message: '请选择' }]}
                        >
                          <Select
                            placeholder='性别'
                            style={{
                              width: '100px',
                              margin: '0 10px',
                            }}
                          >
                            <Option value={'1'} key={'1'}>
                              男性
                            </Option>
                            <Option value={'2'} key={'2'}>
                              女性
                            </Option>
                          </Select>
                        </Form.Item>
                        <div style={{ marginTop: '5px' }}>使用</div>
                      </Col> : <></>}
                  </Col>
                </Col>
                <Col span={16}>
                  <Col className={styles.jlTitle}>
                    <span>开方年龄限制</span>
                  </Col>
                  <Col style={{ display: 'flex' }}>
                    <Col span={1}>
                      <Form.Item
                        name='ageReminder'
                        valuePropName='checked'
                      >
                        <Checkbox
                          onChange={(v) => {
                            setAgeReminderFlag(v?.target.checked)
                          }}
                        />
                      </Form.Item>
                    </Col>
                    {ageReminderFlag ?
                      <Col span={20} style={{ display: 'flex' }}>
                        <div style={{ marginTop: '5px' }}>仅限</div>
                        <Form.Item
                          name='judgmentType'
                          rules={[{ required: true, message: '请选择' }]}
                        >
                          <Select
                            placeholder='请选择'
                            style={{
                              width: '100px',
                              margin: '0 10px',
                            }}
                          >
                            <Option value={'1'} key={'1'}>
                              小于
                            </Option>
                            <Option value={'2'} key={'2'}>
                              大于
                            </Option>
                          </Select>
                        </Form.Item>
                        <Form.Item
                          name='ageLimit'
                          rules={[
                            {
                              pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                              message: '请输入数字',
                            },
                            { required: true, message: '请输入' },
                          ]}
                        >
                          <Input
                            style={{
                              width: '90px',
                            }}
                          ></Input>
                        </Form.Item>
                        <div style={{ marginTop: '5px', marginLeft: '6px' }}>
                          岁患者使用
                        </div>
                      </Col> : <></>}
                  </Col>
                </Col>
                <Col span={24} style={{ position: 'relative' }}>
                  <Form.Item
                    name='allowUseUserId'
                    label='限定开单医生'
                    {...remarkColumnLayout}
                  >
                    <Select
                      style={{ width: '97.4%' }}
                      mode='multiple'
                      allowClear
                      placeholder='医生'
                      options={doctors}
                    />
                  </Form.Item>
                  <Popover
                    content={
                      <div>
                        <p>
                          您可以在这里设定哪些医生有权限开具这个药品的处方，不设置即表明所有医生都可以开具该药品。
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips6} />
                  </Popover>
                </Col>
                <Col span={24} style={{ position: 'relative' }}>
                  <Col className={styles.jlTitle}>
                    <span>库存预警设置</span>
                  </Col>
                  <Col style={{ display: 'flex' }}>
                    <div style={{ marginTop: '5px' }}>库存数量不足</div>
                    <Form.Item
                      name='inventoryAlert'
                      rules={[
                        {
                          pattern: new RegExp(/^[0-9]\d*$/, 'g'),
                          message: '请输入数字',
                        },
                      ]}
                    >
                      <Input
                        placeholder='请输入'
                        style={{
                          width: '160px',
                          margin: '0 10px',
                        }}
                        addonAfter={<span>{form.getFieldValue('accountUnit')}</span>}
                      />
                    </Form.Item>
                    <div style={{ marginTop: '5px' }}>，系统预警提示（发送系统通知）</div>
                  </Col>
                  <Popover
                    content={
                      <div>
                        <p>
                          设置后当这个商品的库存小于设置的值时会在首页消息通知里进行提醒
                        </p>
                      </div>
                    }
                    placement='bottom'
                    title='说明'
                  >
                    <img src={QuestionTipsImg} className={styles.questionTips6} />
                  </Popover>
                </Col>
                {/* 中药材/饮片展示自动清斗设置 */}
                {ZYCYPshow ?
                  <Col span={24} style={{ position: 'relative' }}>
                    <Col className={styles.jlTitle}>
                      <span>自动清斗设置</span>
                    </Col>
                    <Col style={{ display: 'flex' }}>
                      <div style={{ marginTop: '5px' }}>库存单批次数量不足</div>
                      <Form.Item
                        name='autoMergeLimit'
                        rules={[
                          {
                            pattern: new RegExp(/^[0-9]\d*(\.\d)?$/),
                            message: '请输入数字，支持小数点后一位',
                          },
                        ]}
                      >
                        <Input
                          placeholder='请输入'
                          style={{
                            width: '160px',
                            margin: '0 10px',
                          }}
                          addonAfter={<span>盒</span>}
                        />
                      </Form.Item>
                      <div style={{ marginTop: '5px' }}>，系统将会在凌晨自动将该库存合并到其他库存中</div>
                    </Col>
                    <Popover
                      content={
                        <div>
                          <p>
                            当您在这里设置了自动清斗数量时，如果该药品的任何批次库存数量低于您设置的数量，系统将会自动将该库存合并到其他库存中
                          </p>
                          <p>
                            以确保中药库存的整洁。需要注意的是，
                            <span style={{ color: 'red' }}>
                              即使是来自不同目录或厂家的库存，只要名字相同，系统也会将它们合并在一起。
                            </span>
                          </p>
                          <p>
                            这个合并过程会在每天的凌晨自动进行。如果您没有设置自动清斗数量，则系统不会对该药品执行自动清斗操作。
                          </p>
                        </div>
                      }
                      placement='bottom'
                      title='说明'
                    >
                      <img src={QuestionTipsImg} className={styles.questionTips6} />
                    </Popover>
                  </Col> :
                  <></>}
              </Row>
            </Col>
            {/* 右侧内容 */}
            {/* 校医务室药品不展示 */}
            {tenantCategory == 17 ? <></> :
              <>
                <Col span={9} className={props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? styles.elseRightContent : JSON.stringify(detail) !== '{}' ? styles.noSearchrightContent : styles.rightContent}>
                  <Row className={styles.rightContentTitle}>
                    <Col span={6} className={styles.titleText}>价格信息</Col>
                    <Col span={18} className={styles.titleButton}>
                      {/* 医保机构且有医保名称才展示 */}
                      {form.getFieldValue('hilistName') && insuranceArray.length ? (
                        <Button type="primary" size="middle" ghost style={{ marginRight: '10px' }}
                          onClick={() => {
                            const hilistPricUplmtAmtFromGet = form.getFieldValue('hilistPricUplmtAmt')
                            const hilistPricUplmtAmt = hilistPricUplmtAmtFromGet >= 99999 || hilistPricUplmtAmtFromGet == 0
                            if (hilistPricUplmtAmt) {
                              return
                            } else {
                              form.setFieldsValue({
                                retailPrice: hilistPricUplmtAmtFromGet,
                              })
                            }
                          }}
                        >同步限价到售价</Button>
                      ) : <></>}
                      {/* 没有勾选零库存开单展示 */}
                      {detail?.id && !settings?.[Checks.Lkcky] ? (
                        <Button type="primary" size="middle" ghost
                          onClick={() => {
                            setSureVisible(true)
                          }}
                        >同步售价到库存</Button>
                      ) :
                        <></>}
                    </Col>
                  </Row>
                  <Row>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        {...firstColumnLayout}
                        name='retailPrice'
                        label='售价/元'
                        rules={[
                          { required: true },
                          {
                            pattern: new RegExp(/^\d+(\.\d{1,5})?$/, 'g'),
                            message: '请输入保留小数五位以内的数',
                          },
                        ]}
                      >
                        <Input size='middle' allowClear />
                      </Form.Item>
                      <Col className={styles.splitTag}>
                        <Form.Item name='splitTag' valuePropName='checked'>
                          <Checkbox
                            style={{ width: '100px' }}
                            onChange={((e) => {
                              setSplitTag(e.target.checked)
                            })}>允许拆零</Checkbox>
                        </Form.Item>
                      </Col>
                    </Col>
                    {/* 勾选了允许拆零才显示拆零售价 */}
                    {splitTag ?
                      <Col span={12}>
                        <Form.Item
                          name='splitPrice'
                          label='拆零售价/元'
                          rules={[{ required: true }]}
                        >
                          <Input size='middle' allowClear />
                        </Form.Item>
                      </Col> : <></>}
                    <Col span={12}>
                      <Form.Item
                        {...firstColumnLayout}
                        name='stockPrice'
                        label='进价/元'
                        rules={[
                          {
                            pattern: new RegExp(/^\d+(\.\d{1,5})?$/, 'g'),
                            message: '请输入保留小数五位以内的数',
                          },
                        ]}
                      >
                        <Input size='middle' allowClear />
                      </Form.Item>
                    </Col>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='tax'
                        {...firstColumnLayout}
                        label='项目税率'
                        rules={[
                          {
                            pattern: new RegExp(/^(0(\.\d{1,2})?|1(\.0{1,2})?)$/),
                            message: '请输入0~1之间的数字，支持小数点后两位',
                          },
                        ]}
                      >
                        <Input size='middle' />
                      </Form.Item>
                      <Popover
                        content={
                          <div>
                            <p>
                              如果您接入了电子发票，且需要控制每个项目的税率，可以在此处填写该项目的税率，如果您属于免税机构，则不需要填写。
                            </p>
                            <p>
                              如果您需要批量修改所有项目的税率，也可与我们的服务人员联系。
                            </p>
                            <p>格式为：0~1，保留2位小数点，如0.03</p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <img src={QuestionTipsImg} className={styles.questionTips4} />
                      </Popover>
                    </Col>
                    {/* 1 药店 */}
                    {tenantCategory == 1 ?
                      <Col span={12}>
                        <Form.Item
                          {...firstColumnLayout}
                          label='会员价'
                        >
                          <Row className={styles.hbCol}>
                            <Col span={7}>
                              <Form.Item name='discountType' noStyle initialValue={0}>
                                <Select
                                  onChange={(val) => {
                                    const memberPrice = form.getFieldValue('memberPrice')
                                    if (memberDiscountType === 0 && val === 1) {
                                      // 折扣 → 特价
                                      setCachedDiscountPrice(memberPrice)
                                      form.setFieldsValue({ memberPrice: cachedSpecialPrice ?? undefined })
                                    } else if (memberDiscountType === 1 && val === 0) {
                                      // 特价 → 折扣
                                      setCachedSpecialPrice(memberPrice)
                                      form.setFieldsValue({ memberPrice: cachedDiscountPrice ?? undefined })
                                    }
                                    setMemberDiscountType(val)
                                  }}
                                >
                                  <Select.Option value={0}>折扣</Select.Option>
                                  <Select.Option value={1}>特价</Select.Option>
                                </Select>
                              </Form.Item>
                            </Col>
                            <Col span={17}>
                              <Form.Item
                                name='memberPrice'
                                noStyle
                                rules={[
                                  memberDiscountType === 1
                                    ? {
                                      pattern: new RegExp(/^(0|[1-9]\d*)(\.\d{1,5})?$/),
                                      message: '请输入数字，支持小数点后五位',
                                    }
                                    : {
                                      pattern: new RegExp(/^(100|[1-9]?\d)$/),
                                      message: '折扣请输入0-100的整数',
                                    },
                                ]}
                              >
                                <Input
                                  size='middle'
                                  allowClear
                                  addonAfter={memberDiscountType === 1 ? '元' : '%'}
                                  onBlur={(e) => {
                                    if (memberDiscountType === 1 && e.target.value) {
                                      const num = Number(e.target.value)
                                      if (!isNaN(num)) {
                                        form.setFieldsValue({ memberPrice: num.toFixed(5) })
                                      }
                                    }
                                  }}
                                />
                              </Form.Item>
                            </Col>
                          </Row>
                        </Form.Item>
                      </Col> :
                      <></>
                    }
                  </Row>
                  <Row style={{ marginTop: '4px' }}>
                    <Col span={12} className={styles.titleText}>医保匹配信息</Col>
                  </Row>
                  <Row>
                    <Col span={24} style={{ position: 'relative' }} className={styles.matchInfo}>
                      <Form.Item
                        label='医保对码'
                        {...firstColumnLayout}
                      >
                        <Row className={styles.hbYDMCol} onClick={(() => {
                          matching()
                        })}>
                          <Col span={12}>
                            <Form.Item name='hilistName'>
                              <Input
                                size='middle'
                                disabled
                                style={{ textAlign: 'left' }}
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item name='hiListCode' >
                              <Input
                                style={{ textAlign: 'right', fontSize: '12px', height: '30px' }}
                                size='middle'
                                disabled
                              />
                            </Form.Item>
                          </Col>
                        </Row>
                      </Form.Item>
                      <span className={styles.tips} style={{ cursor: 'pointer' }}
                        onClick={(() => {
                          matching()
                        })}
                      >{form.getFieldValue('hilistName') ? '重新匹配' : '立即匹配'}</span>
                    </Col>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='rewriteHilistCode'
                        {...firstColumnLayout}
                        label='自定义医保国码'
                      >
                        <Input size='middle' />
                      </Form.Item>
                      <Popover
                        content={
                          <div>
                            <p>
                              当您知道此项目的医保国家编码，而医保匹配又搜索不到该项目时，您可以跳过匹配并直接填写医保国家编码。
                            </p>
                            <p>
                              在编码正确的情况下仍可进行医保结算；系统将会优先使用自定义医保国码进行医保结算。
                            </p>
                            <p>
                              请注意：使用自定义医保国码时，编码的限价与甲乙分类将不能正确展示，但不会影响医保刷卡与报销。
                            </p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <img src={QuestionTipsImg} className={styles.questionTips7} />
                      </Popover>
                    </Col>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='proviceHilistCode'
                        {...firstColumnLayout}
                        label='医保省市编码'
                      >
                        <Input size='middle' />
                      </Form.Item>
                      <Popover
                        content={
                          <div>
                            <p>
                              部分项目必须国码配合省码一起上传才可以进入医保报销。
                            </p>
                            <p>
                              如果有需要指定省码的项目，请将省码填写到这里，例如血液透析仪的省码为：”cl311000100x“。
                            </p>
                            <p>
                              请注意：不需要传省码的项目请不要填写，以免影响报销；若有疑问，您可以联系客服人员。
                            </p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <img src={QuestionTipsImg} className={styles.questionTips6} />
                      </Popover>
                    </Col>
                    <Col span={12} style={{ position: 'relative' }}>
                      <Form.Item
                        name='limitCount'
                        {...firstColumnLayout}
                        label='医保限量开方'
                        rules={[
                          {
                            pattern: /^\d+(\.\d{1,2})?$/,
                            message: '请输入数字（最多两位小数）',
                          },
                        ]}
                      >
                        <Input size='middle' />
                      </Form.Item>
                      <Popover
                        content={
                          <div>
                            <p>当您设置了医保限量开方数量后，如果该商品</p>
                            <p>在医保结算时数量超过了设置的医保限量时，</p>
                            <p>
                              超出部分会
                              <a style={{ color: 'red' }}>
                                自动转为自费结算，且不会传给医保。
                              </a>
                            </p>
                            <p>若类型为中草药时，限量为每贴数量。</p>
                            <p>
                              <a style={{ color: 'grey' }}>
                                该功能不支持拆零，不设置即不启用。
                              </a>
                            </p>
                          </div>
                        }
                        placement='bottom'
                        title='说明'
                      >
                        <img src={QuestionTipsImg} className={styles.questionTips6} />
                      </Popover>
                    </Col>
                  </Row>
                  {form.getFieldValue('hilistName') ? <>
                    <Row className={styles.ybMessage}>
                      <Col span={24} className={styles.ybMessageItem}>医保规格：{medicalModalInfo?.spec}</Col>
                      <Col span={12} className={styles.ybMessageItem}>准字：{medicalModalInfo?.aprvno}</Col>
                      <Col span={12} className={styles.ybMessageItem}>厂家：{medicalModalInfo?.prodentpName}</Col>
                      {medicalModalInfo?.pacmatl ? <Popover
                        placement='top'
                        content={<div style={{ maxWidth: '500px' }}>{medicalModalInfo?.pacmatl}</div>}
                      >
                        <Col span={12} className={styles.ybMessageItem}>包装材质：{medicalModalInfo?.pacmatl}</Col>
                      </Popover> : <Col span={12} className={styles.ybMessageItem}>包装材质：{medicalModalInfo?.pacmatl}</Col>}
                      <Col span={12} className={styles.ybMessageItem}>限价：{medicalModalInfo?.hilistPricUplmtAmt}</Col>
                      <Col span={24} className={styles.ybMessageItem}>自付比例信息：{medicalModalInfo?.zfblDescription}</Col>
                      {cityCode?.indexOf('32') == 0 ? <Col span={24} style={{ lineHeight: '26px' }}>挂网价:{medicalModalInfo?.onlinePrice}</Col> : ''}
                      <Col span={24} className={styles.ybMessageItem}>备注：{medicalModalInfo?.memo}</Col>
                    </Row>
                  </> : <></>}
                  <Row style={{ marginTop: '6px' }}>
                    <Col span={24} className={styles.ybjsfsMessage}>
                      <Row style={{ display: 'flex', alignItems: 'center' }}>
                        <span className={styles.jlTitle} style={{ width: '98px', lineHeight: '32px' }}>医保结算方式：</span>
                        <Form.Item
                          {...firstColumnLayout}
                          name='forceYearAccount'
                        >
                          <Radio.Group
                            defaultValue={0}
                            style={{ width: '400px' }}
                          >
                            <Radio value={0}>优先统筹</Radio>
                            <Radio value={1}>优先个账（包含本年、历年）</Radio>
                            <Radio value={2}>自费</Radio>
                          </Radio.Group>
                        </Form.Item>
                      </Row>
                    </Col>
                  </Row>
                </Col>
              </>}
          </Row>
        </Form >
        <div className={styles.bottomContent} style={{ position: 'relative' }}>
          {/* 编辑展示 */}
          {JSON.stringify(detail) != '{}' ? (
            <>
              {detail?.state == 1 ?
                <Popconfirm
                  title={'确认进行注销操作吗？'}
                  onConfirm={() => {
                    setStateStatus(detail.id, true)
                  }}
                  onCancel={() => {
                    setStateStatus(detail.id, false)
                  }}
                  okText='确认并同步删除套餐/未收费处方'
                  //取消按钮当做注销，确认按钮当做强行注销
                  cancelButtonProps={{
                    style: {
                      border: 0,
                      backgroundColor: '#027AFF',
                      color: '#FFF',
                    },
                  }}
                  okButtonProps={{
                    style: {
                      border: 0,
                      backgroundColor: '#fe2121',
                      color: '#FFF',
                    },
                  }}
                  cancelText='确认'
                >
                  <Button type="primary" ghost danger style={{ position: 'absolute', left: '20px' }}>注销</Button>
                </Popconfirm> :
                <Popconfirm
                  title={'确认进行启用操作？'}
                  onConfirm={() => {
                    setStateStatus(detail.id, false)
                  }}
                  onCancel={() => {
                    return
                  }}
                  okText='确认'
                  cancelText='取消'
                >
                  <Button type="primary" ghost style={{ position: 'absolute', left: '20px' }}>启用</Button>
                </Popconfirm>
              }
            </>
          ) : (
            <></>
          )}
          <Button
            style={{ marginRight: '10px' }}
            onClick={(() => {
              returnMessage()
            })}
          >
            取消
          </Button>
          <Button
            type="primary"
            loading={isSubmitLoading}
            style={{ marginRight: '10px' }}
            onClick={(() => {
              form.submit()
              setSaveAndContinue(false)
            })}>
            保存
          </Button>
          {/* 新增展示保存并继续 */}
          {JSON.stringify(detail) != '{}' || props?.flag == '/msfxFlag' || props?.flag == '/homeFlag' ? (
            <></>
          ) : <Button
            loading={isSubmitLoading}
            onClick={(() => {
              form.submit()
              setSaveAndContinue(true)
            })}>
            保存并继续
          </Button>}
        </div>
        {/* 生产厂家 supplierCategory=1  供应商 supplierCategory=0*/}
        <SupplierModal
          supplierCategory={flag}
          visible={isModalVisible}
          switchModal={() => {
            setIsModalVisible(false)
            setIsAddModalVisible(true)
          }}
          onOk={() => {
            setIsModalVisible(false)
            setFlag('')
          }}
          onCancel={() => {
            setIsModalVisible(false)
            setFlag('')
          }}
          onRecord={(record: any) => {
            setTenantSupplierId(record.id)
            if (flag == 0) {
              form.setFieldsValue({
                normalGysName: record.companyName,
              })
            } else {
              form.setFieldsValue({
                tenantSupplierName: record.companyName,
                lstdLicHolder: record.companyName,
              })
            }
          }}
        />
        {/* 新增供应商 */}
        <SupplierSaveModal
          visible={isAddModalVisible}
          supplierCategory={flag}
          onOk={() => {
            setIsAddModalVisible(false)
            dispatch(setCurrent(1))
            setIsModalVisible(true)
          }}
          onCancel={() => {
            setIsAddModalVisible(false)
            setIsModalVisible(true)
          }}
        />
        {/* 从医保目录搜索 */}
        <MedicalModal
          visible={medicalModalVisible}
          onOk={() => {
            setMedicalModalVisible(false)
          }}
          onCancel={() => {
            setMedicalModalVisible(false)
          }}
          onRecord={(item) => {
            getInsuranceRrecordSetFiles(item)
            //套用医保限价的价格（当前价格为空时）
            recordPP(item)
          }}
          componentItem={{
            ...componentItem,
            insuranceCode: insuranceArray.length
              ? insuranceArray[0].insuranceCode
              : '',
          }}
        />
        {/* 同步售价到库存 */}
        <Modal
          width={500}
          title='确认操作'
          confirmLoading={loading}
          destroyOnClose
          visible={sureVisible}
          onCancel={() => setSureVisible(false)}
          onOk={() => {
            setLoading(true)
            const params = {
              id: detail?.id,
              stockPrice: form.getFieldValue('stockPrice'),
              retailPrice: form.getFieldValue('retailPrice'),
              flag: isChecked ? 1 : 0,
            }
            dispatch(getSyncInventoryAsync(params))
              .then(unwrapResult)
              .then((v: any) => {
                notification.success({
                  message: v,
                })
              })
              .finally(() => {
                setLoading(false)
                setSureVisible(false)
              })
          }}
        >
          <div style={{ paddingLeft: '10px' }}>
            <div style={{ display: 'flex' }}>
              <ExclamationCircleFilled
                style={{
                  color: '#FFAE55',
                  fontSize: 18,
                }}
              />
              <div style={{ margin: '-4px 0 0 10px' }}>
                <div>
                  是否给该商品的所有库存价格调整为：售价
                  {form.getFieldValue('retailPrice')}元
                </div>
                <div>如需生成变动记录，请在左下角勾选上生成变动记录</div>
              </div>
            </div>
            <Checkbox
              checked={isChecked}
              onChange={() => {
                setIsChecked(!isChecked)
                localStorage.setItem('SFSCBDJLHTJJL', JSON.stringify(!isChecked))
              }}
              style={{ margin: '10px 0', position: 'absolute', bottom: '4px' }}
            >
              生成调价记录
            </Checkbox>
          </div>
        </Modal>
      </div >
    </>
  )
}
